'use strict';

const collectionFactory = require('./collection.factory');

const flightDetailsCollection = collectionFactory({
    dataUrl: 'getflightdetails',

    getFreeCancellationLimitDTO() {
        return this.get('freeCancellationLimitDTO') || {hoursApart: 0};
    },

    getFreeCancellationLimitHoursApart() {
        return this.getFreeCancellationLimitDTO().hoursApart;
    },

    isDynpack() {
        return Odigeo.Utils.isRequestApp('dp');
    },

    isUpsell() {
        return Odigeo.Utils.isRequestApp('upsell');
    },

    hasAccommodation() {
        return this.isDynpack() || this.isUpsell();
    },

    getSegments() {
        return this.get('segments') || [];
    },
});

module.exports.getInstance = flightDetailsCollection.getInstance;
